import React from 'react';

import {
	useClassNames,
} from '@common';

import './DefaultTable.scss';
interface DefaultTableProps extends React.TableHTMLAttributes<HTMLTableElement>{
	thead?: JSX.Element,
	tbody: JSX.Element,
	tfoot?: JSX.Element,
}

function DefaultTable(props: DefaultTableProps): JSX.Element {
	const {
		thead,
		tbody,
		tfoot,
		className,
		...tableProps
	} = props;

	const classes = useClassNames('table', className);

	return (
		<div className="table-wrapper">
			<table className={classes} {...tableProps}>
				<thead>
					{thead}
				</thead>
				<tbody>
					{tbody}
				</tbody>
				<tfoot>
					{tfoot}
				</tfoot>
			</table>
		</div>
	);
}

const MemoisedDefaultTable = React.memo(DefaultTable);

export {MemoisedDefaultTable as DefaultTable};